import * as React from "react";
import type { SVGProps } from "react";
const SvgAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#26447C"
      d="M13.125 10.875v-6.75h-2.25v6.75h-6.75v2.25h6.75v6.75h2.25v-6.75h6.75v-2.25z"
    />
  </svg>
);
export default SvgAdd;
